import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year4/Autumn/Area/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Area',
  field: 'Measurement',
  weeks: [8, 8],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () => import(/* webpackChunkName: "Year4/Autumn/Area/1WhatIsArea" */ './1WhatIsArea')
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(/* webpackChunkName: "Year4/Autumn/Area/2CountSquares" */ './2CountSquares')
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () => import(/* webpackChunkName: "Year4/Autumn/Area/3MakeShapes" */ './3MakeShapes')
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(/* webpackChunkName: "Year4/Autumn/Area/4CompareAreas" */ './4CompareAreas')
    })
  ]
});
export default Block;
